// extracted by mini-css-extract-plugin
export var card = "_sr-0";